import { render, staticRenderFns } from "./ReferralPromotionPickerFormItem.vue?vue&type=template&id=4a7e2998&"
import script from "./ReferralPromotionPickerFormItem.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionPickerFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports